import React, { ReactElement } from 'react';

import type { CompanyInterface } from 'interfaces/company.interface';
import CompanyViewInfoMetadataItem from 'components/company-view/company-view-info/metadata/item/item';
import CompanyViewInfoMetadataSocials from 'components/company-view/company-view-info/metadata/socials/socials';
import Link from 'atomic/link/link';

const CompanyViewInfoMetadataContent: React.FC<{ company: CompanyInterface; }> = ({ company }): ReactElement => (
    <>
        <div className="company-view-info__metadata-header">
            Dane firmy
        </div>
        <CompanyViewInfoMetadataItem label="telefon" content={company.phone || 'brak telefonu'}/>
        <CompanyViewInfoMetadataItem
            label="email"
            content={
                company.email
                    ? (
                        <Link href={`mailto:${company.email}`} title={company.email} target="_blank" className="company-view-info__metadata-link">
                            {company.email}
                        </Link>
                    )
                    : 'brak emaila'
            }
        />
        {(company.socials?.facebook || company.socials?.instagram) && (
            <CompanyViewInfoMetadataItem
                label="social"
                content={<CompanyViewInfoMetadataSocials {...company.socials}/>}
            />
        )}
        <CompanyViewInfoMetadataItem
            label="adres"
            content={
                company.street
                    ? (
                        <>
                            {company.street}
                            <br/>
                            {`${company.postal} ${company.city}`}
                        </>
                    )
                    : 'brak adresu'
            }
        />
    </>
);

export default CompanyViewInfoMetadataContent;
